export default {
  bind(el, binding) {
    const clickOutsideHandler = event => {
      const { handlerElement, ignore, handler } = binding.value
      const clickTarget = event.target

      if (!el.parentNode) {
        return
      }

      let isClickIgnored = false

      if (ignore && ignore.length > 0) {
        isClickIgnored = ignore.some(ref => {
          if (!ref) {
            return false
          }

          const elToIgnore = ref.$el || ref

          return elToIgnore.contains(clickTarget)
        })
      }

      if (!isClickIgnored && !el.contains(clickTarget)) {
        if (typeof handler === 'function') {
          handler(event)
        }
      }
    }

    el.__vueClickOutside__ = clickOutsideHandler
    document.addEventListener('click', clickOutsideHandler)
  },

  unbind(el) {
    document.removeEventListener('click', el.__vueClickOutside__)
    delete el.__vueClickOutside__
  },
}
